import { Fact } from '../../common/fact';

require('./facts-slider-view.component.scss');

class FactsSliderViewController {
  constructor($scope, $element) {
    this.$scope = $scope;
    this.isImage = Fact.isImage;
  }

  get selectedImage() {
    if (!this.selectedFact || !this.isImage(this.selectedFact)) {
      return;
    }
    let fileName = this.selectedFact['agent_attachedfile.data'];
    return '/media/' + fileName;
  }

}

export const FactsSliderViewComponent = {
  bindings  : {
    filter      : '<',
    selectedFact: '<',
  },
  template  : require('./facts-slider-view.component.html'),
  controller: FactsSliderViewController,
};



// WEBPACK FOOTER //
// ./src/facts/slider/facts-slider-view.component.js